<template>
    <div id="contenedor-componente-editar-programa">
      <v-card flat>
        <v-card-text>
          <v-form v-model="formularioValido" ref="editarPrograma">
            <v-row align="center" justify="start">
              <date-picker
                cols="12"
                v-model="estePrograma.fechaInicio"
                label="Fecha Inicio"
                :max="fechaDeTerminoMes"
                :rules="[mixReglas.requerido]">
              </date-picker>
              <date-picker
                cols="12"
                v-model="estePrograma.fechaTermino"
                label="Fecha Termino"
                :min="estePrograma.fechaInicio"
                :max="fechaDeTerminoMes"
                :rules="[mixReglas.requerido]">
              </date-picker>
              <text-field
                cols="12"
                v-model.number="estePrograma.monto"
                label="Monto"
                es-dinero
                prefix="$"
                @keyup.enter.native="editar"
                :rules="[mixReglas.requerido]">
              </text-field>
              <v-col cols="12">
                <v-btn
                  @click="editar"
                  color="success"
                  block
                  :disabled="!formularioValido">
                  <v-icon>edit</v-icon>
                  editar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
</template>

<script>
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextField from '@/components/inputs/TextField.vue';

export default {
  name: 'ComponenteAgregarPrograma',
  props: {
    fechaInicio: {
      type: String,
      required: false,
      default() {
        const ahora = new Date();
        return `${ahora.getFullYear()}-${(ahora.getMonth() + 1)}-${ahora.getDate()}`;
      },
    },
    fechaTermino: {
      type: String,
      required: false,
    },
    estePrograma: Object,
  },
  components: {
    DatePicker,
    TextField,
  },
  data() {
    return {
      formularioValido: false,
      fechaDeTerminoMes: '',
      // programa: {
      //   fechaInicio: this.fechaInicio,
      //   fechaTermino: '',
      //   plazo: 0,
      //   monto: 0,
      // },
    };
  },
  mounted() {},
  methods: {
    calcularFechaTermino() {
      if (!this.estePrograma.fechaInicio) return;
      const fechaInicio = new Date(`${this.estePrograma.fechaInicio} 00:00:0`);
      const mesFormatoDosDigitos = (`0${(fechaInicio.getMonth() + 1)}`).slice(-2);

      const diasDelMes = new Date(fechaInicio.getFullYear(), (fechaInicio.getMonth() + 1), 0)
        .getDate();
      const fechaTermino = new Date(`${fechaInicio.getFullYear()}-${mesFormatoDosDigitos}-${diasDelMes} 00:00:0`);

      if (fechaTermino > this.getFechaTerminoContrato) {
        this.fechaDeTerminoMes = this.fechaTermino;
      } else {
        this.fechaDeTerminoMes = `${fechaInicio.getFullYear()}-${mesFormatoDosDigitos}-${diasDelMes}`;
      }

      if (!this.estePrograma.fechaTermino) {
        this.estePrograma.fechaTermino = this.fechaDeTerminoMes;
      }
    },
    calcularPlazo() {
      const fechaInicio = new Date(this.estePrograma.fechaInicio);
      const fechaTermino = new Date(this.estePrograma.fechaTermino);

      // Calcular
      const diferenciaMiliSegundos = Math.abs(fechaTermino - fechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

      this.estePrograma.plazo = (diferenciaDias + 1);
    },
    editar() {
      this.$emit('seEdito');
    },
  },
  computed: {
    getFechaTerminoContrato() {
      return new Date(`${this.fechaTermino} 00:00:0`);
    },
  },
  watch: {
    programa: {
      handler() {
        this.calcularPlazo();
        this.calcularFechaTermino();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">

</style>
